/**
 * sorts a list of objects by id, where all objects in the list have the property id.
 */
export const ById = (a: any, b: any) => a.id.localeCompare(b.id);
export const ByName = (a: any, b: any) => a.name.localeCompare(b.name);
